import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';

import { localStorageCartId } from '../../_common/constants';
import { CartsService } from '../../_services/carts.service';
import { LoginService } from '../../_services/login.service';
import { PromotionService } from '../../_services/promotion.service';
import { StyleService } from '../../_services/style.service';
import { Cart } from '../../_models/cart';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-layout-header',
    styleUrls: ['./layout-header.component.scss'],
    templateUrl: './layout-header.component.html'
})
export class LayoutHeaderComponent implements OnDestroy, OnInit {
    private cartCountSubscription: Subscription;
    private promotionSubscription: Subscription;

    cartCount = 0;
    isDevelopment: boolean;
    isLoading = true;
    isShowingHeader = true;
    timeRemainingPromotion: number;
    webApiUrl: string;

    backgroundColor: string;
    backgroundColorTextbox: string;
    fontColor: string;
    secondaryFontColor: string;

    counter1$: Observable<number>;
    counter2$: Observable<number>;
    time1: Date = new Date(Date.UTC(2019, 11, 29, 7, 0, 0));
    time2: Date = new Date(Date.UTC(2020, 0, 15, 0, 0, 0));
    timeRemaining1: number;
    timeRemaining2: number;
    timerSubscription1: Subscription;
    timerSubscription2: Subscription;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly cartsService: CartsService,
        private readonly loginService: LoginService,
        private readonly promotionService: PromotionService,
        private readonly styleService: StyleService) {
        if (environment.production) {
            this.isDevelopment = false;
            // Small security change to make sure api url is never exposed in production.
            this.webApiUrl = '';
        } else {
            this.isDevelopment = true;
            this.webApiUrl = environment.webApiUrl;
        }
    }

    ngOnDestroy(): void {
        if (this.cartCountSubscription) {
            this.cartCountSubscription.unsubscribe();
        }
        if (this.promotionSubscription) {
            this.promotionSubscription.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.isLoading = true;

        // this.time1 = new Date(Date.now() + 10000);
        // this.time2 = new Date(Date.now() + 20000);

        this.startTimers();
        this.subscribeToStyling();

        const cartId = localStorage.getItem(localStorageCartId);

        if (cartId !== null) {
            let userId = 0;
            const authUser = this.loginService.getLoggedInUser();
            if (authUser !== null) {
                userId = authUser.userId;
            }

            this.cartsService.get(cartId as string, userId).subscribe(
                (cart: Cart) => {
                    this.cartCount = cart.getTotalItemCount();
                    this.isLoading = false;
                },
                (error: any) => {
                    this.cartCount = 0;
                    this.isLoading = false;
                }
            );
        } else {
            this.cartCount = 0;
            this.isLoading = false;
        }

        this.cartCountSubscription = this.cartsService.cartCount.subscribe(
            (count: number) => {
                this.cartCount = count;
            });

        this.promotionService.promotionSecondsRemaining.subscribe(
            (seconds: number) => {
                this.timeRemainingPromotion = seconds;
            });

        this.route.queryParams.subscribe((params) => {
            if (params['app']) {
                this.isShowingHeader = false;
            }
        });
    }

    isLoggedIn(): boolean {
        return this.loginService.isLoggedIn();
    }

    isPromotionInProgress(): boolean {
        return this.timeRemainingPromotion && this.timeRemainingPromotion > 0;
    }

    isEventActive(eventName): boolean {
        switch(eventName) {
            case "cottonBowl":
                return environment.cottonBowlEventId > 0;
            case "orangeBowl":
                return environment.orangeBowlEventId > 0;
            case "fiestaBowl":
                return environment.fiestaBowlEventId > 0;
            case "playoffSemifinal":
                return environment.playoffSemifinalEventId > 0;
            case "peachBowl":
                return environment.peachBowlEventId > 0;
            case "sugarBowl":
                return environment.sugarBowlEventId > 0;
            case "roseBowl":
                return environment.roseBowlEventId > 0;
            default:
                return false;
        }
    }

    isEventComingSoon(eventName): boolean {
        switch(eventName) {
            case "cottonBowl":
                return environment.cottonBowlEventId == 0;
            case "orangeBowl":
                return environment.orangeBowlEventId == 0;
            case "fiestaBowl":
                return environment.fiestaBowlEventId == 0;
            case "playoffSemifinal":
                return environment.playoffSemifinalEventId == 0;
            case "peachBowl":
                return environment.peachBowlEventId == 0;
            case "sugarBowl":
                return environment.sugarBowlEventId == 0;
            case "roseBowl":
                return environment.roseBowlEventId == 0;
            default:
                return false;
        }
    }

    isAnyComingSoon(): boolean {
        return environment.cottonBowlEventId == 0 ||
            environment.orangeBowlEventId == 0 ||
            environment.fiestaBowlEventId == 0 ||
            environment.playoffSemifinalEventId == 0 ||
            environment.peachBowlEventId == 0 ||
            environment.sugarBowlEventId == 0 ||
            environment.roseBowlEventId == 0;
    }

    private startTimers(): void {
        this.timeRemaining1 = Math.floor((this.time1.getTime() - new Date().getTime()) / 1000);

        if (this.timeRemaining1 > 0) {
            this.counter1$ = Observable.interval(1000).map((x) => {
               return Math.floor((this.time1.getTime() - new Date().getTime()) / 1000);
            });

            this.timerSubscription1 = this.counter1$.subscribe((x) => {
                this.timeRemaining1 = x;
            });
        } else {
            this.timeRemaining1 = 0;
        }

        this.timeRemaining2 = Math.floor((this.time2.getTime() - new Date().getTime()) / 1000);

        if (this.timeRemaining2 > 0) {
            this.counter2$ = Observable.interval(1000).map((x) => {
               return Math.floor((this.time2.getTime() - new Date().getTime()) / 1000);
            });

            this.timerSubscription2 = this.counter2$.subscribe((x) => {
                this.timeRemaining2 = x;
            });
        } else {
            this.timeRemaining2 = 0;
        }
     }

    private subscribeToStyling() {
        this.styleService.getHeaderStyling().subscribe(message => {
            if (message != null) {
                this.backgroundColor = message.backgroundColor;
                this.backgroundColorTextbox = message.backgroundColorTextbox;
                this.fontColor = message.fontColor;
                this.secondaryFontColor = message.secondaryFontColor;
            } else {
                this.backgroundColor = null;
                this.backgroundColorTextbox = null;
                this.fontColor = null;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/layout/layout-header/layout-header.component.ts